export default __webpack_public_path__ + "static/media/password.aa25cbf8.png";